import React from 'react';
import { SettingsModel } from 'src/models';

interface ColorTableProps {
  colors: SettingsModel[];
  selectedColors: SettingsModel[];
  colorChanges: (colors: SettingsModel[]) => void;
  isLoading?: boolean;
}

const toHex6 = (color: string): string => {
  if (!color || !color.startsWith('#')) return '#000000';
  const hex = color.slice(0, 7);
  return /^#[0-9a-fA-F]{6}$/.test(hex) ? hex : '#000000';
};

export const ColorTable = ({ colors, selectedColors, colorChanges, isLoading }: ColorTableProps) => {
  if (isLoading) {
    return <div style={{ textAlign: 'center', padding: '12px', color: 'var(--muted)', fontSize: '.8rem' }}>Loading…</div>;
  }

  const getCurrentValue = (name: string, defaultValue: string) =>
    selectedColors.find(c => c.name === name)?.value || defaultValue;

  const handleChange = (name: string, value: string) => {
    const newColors = selectedColors.filter(c => c.name !== name);
    newColors.push({ name, value });
    colorChanges(newColors);
  };

  return (
    <table className="color-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Current Color</th>
        </tr>
      </thead>
      <tbody>
        {colors.map(c => {
          const currentValue = getCurrentValue(c.name, c.value);
          const hexDisplay = (currentValue || c.value).toUpperCase();
          const inputValue = toHex6(currentValue || c.value);
          const inputId = `color-input-${c.name}`;

          return (
            <tr key={c.name}>
              <td className="color-name">{c.name}</td>
              <td>
                <div className="color-cell">
                  <input
                    type="color"
                    id={inputId}
                    className="color-swatch"
                    value={inputValue}
                    onChange={e => handleChange(c.name, e.target.value)}
                    aria-label={`Color for ${c.name}`}
                  />
                  <button
                    className="color-hex"
                    onClick={() => document.getElementById(inputId)?.click()}
                    title="Click to change color"
                    type="button"
                  >
                    {hexDisplay}
                  </button>
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
